export default "__VITE_ASSET__CYnkFy7q__"